import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import SubmissionFrame from '../dashboard-v2/components/SubmissionFrame.tsx';

function Submission() {
  const [data, setData] = useState([]);

  const columns: GridColDef[] = [
    {
      field: 'sub_id',
      headerName: 'ID',
      headerAlign: 'center',
      width: 20,
      align: 'center',
      renderCell: (params) => (
        <a href={`/dashboard/submissions/${params.row.sub_id}`}>{params.value}</a>
      )
    },
    {
      field: 'sub_text',
      headerName: 'Sub Title',
      headerAlign: 'center',
      width: 100,
      renderCell: (params) => (
        <a href={`/dashboard/submissions/${params.row.sub_id}`}>{params.value}</a>
      )
    },
    { field: 'sub_grader', headerName: 'Grader', width: 60, align: 'center' },
    {
      field: 'sub_order_number',
      headerName: 'Order #',
      headerAlign: 'center',
      width: 70,
      align: 'center',
      renderCell: (params) => (
        <a href={`/dashboard/submissions/${params.row.sub_id}`}>{params.value}</a>
      )
    },
    { field: 'sub_total_cards', headerName: 'Cards', width: 70, align: 'center' },
    {
      field: 'sub_total_cost',
      headerName: 'Total Cost',
      headerAlign: 'center',
      width: 70,
      align: 'right',
      valueFormatter: ({ value }) => (value ? `$${value.toFixed(2)}` : '$0.00')
    },
    {
      field: 'sub_date',
      headerName: 'Sub Date',
      headerAlign: 'center',
      width: 75,
      align: 'center',
      valueGetter: ({ value }) => new Date(value),
      valueFormatter: ({ value }) => value.toLocaleDateString()
    },
    {
      field: 'sub_return_date',
      headerName: 'Return Date',
      headerAlign: 'center',
      width: 85,
      align: 'center',
      valueGetter: ({ value }) => new Date(value),
      valueFormatter: ({ value }) => value.toLocaleDateString()
    },
  ];

  useEffect(() => {
    axios.get('https://api.alientrader.cards/submission')
      .then(res => setData(res.data))
      .catch(err => console.error('Error fetching data:', err));
  }, []);

  return (
    <SubmissionFrame>
      {/* optional: clickable title — remove if you don’t want it */}
      {/* <h5 className="frame-title frame-title--red">SUBMISSIONS</h5> */}
      <div style={{ width: '100%', height: '100%' }}>
        <DataGrid
          rows={data}
          columns={columns}
          className="my-grid"
          getRowId={(row) => row.sub_id}
          rowHeight={30}
          sx={{
            color: '#fff',
            border: 'none',
            '&, .MuiDataGrid-withBorderColor': {
              borderColor: 'rgba(255,255,255,.12)',
            },
            '& .MuiDataGrid-columnHeaders': {
              background: 'rgba(255,255,255,.06)',
              color: '#fff',
              fontSize: 11,
            },
            '& .MuiDataGrid-cell': { fontSize: 10 },
            '& .MuiDataGrid-virtualScroller': { background: 'transparent' },
            /* footer — combine background + your color/size in ONE rule */
            '& .MuiDataGrid-footerContainer': {
              background: 'rgba(255,255,255,.06)',
              color: '#ff4d4d',
              fontSize: '0.75rem',
              fontFamily: 'Orbitron, sans-serif',
            },
            /* links */
            '& a': {
              color: '#ff9c9cff',
              textDecoration: 'none',
            },
            /* "Rows per page" text in the pagination area */
            '& .MuiTablePagination-root': {
              color: '#ffffffff',
              fontSize: '0.75rem',
            },
            '& .MuiTablePagination-selectLabel': {
              fontSize: '0.7rem',   // 👈 change font size here
              color: '#ff4d4d',     // optional color
              fontFamily: 'Orbitron, sans-serif'
            },
            '& .MuiTablePagination-displayedRows': {
              fontSize: '0.8rem',   // 👈 matches rows per page text
              color: '#ff4d4d'
            },
            '& .MuiTablePagination-toolbar': {
              fontSize: '0.9em',      // 👈 makes all text inside 10% smaller
              transform: 'scale(0.8)', // 👈 actually shrinks the entire toolbar
              transformOrigin: 'left center', // keeps alignment tidy
              minHeight: 'unset', // prevents MUI from forcing default height
            },
            /* Tooltip that shows “Menu” when you hover the header menu icon */
            '& .MuiTooltip-tooltip': {
              backgroundColor: 'rgba(255,77,77,0.95)',
              color: '#fff',
              fontSize: '0.75rem',
              border: '1px solid rgba(255,77,77,0.6)',
            },

            /* Column menu popover */
            '& .MuiDataGrid-menu .MuiPaper-root': {
              backgroundColor: 'rgba(20,20,20,0.95)',
              border: '1px solid rgba(255,77,77,0.4)',
              color: '#fff',
            },
            '& .MuiDataGrid-menu .MuiMenuItem-root': {
              color: '#fff',
              fontSize: '0.85rem',
            },
            '& .MuiDataGrid-menu .MuiMenuItem-root:hover, \
       .MuiDataGrid-menu .MuiMenuItem-root.Mui-selected': {
              backgroundColor: 'rgba(255,77,77,0.18)',
            },
            '& .MuiDataGrid-menu .MuiDivider-root': {
              borderColor: 'rgba(255,77,77,0.3)',
            },
          }}
        />

      </div>
    </SubmissionFrame>
  );
}

export default Submission;
